/* eslint-disable import/prefer-default-export */

export const lazyLoadInternalComp = (compName) => () => import(`@/components/${compName}`);
